export enum SpeakingCareerAreasEnum {
   None = 0,
 FinanceAndConsulting = 1,
 LawAndPolicy = 2,
 MedicineHealthcareResearch = 4,
 TechnologyComputerScience = 8,
 EngineeringSciences = 16,
 BusinessEntrepreneurship = 32
} 